// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2E6Xs","content":"LayoutSettings_content__2d44Y"};